var Component = require("!../../../../../../../shared/frontend/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../shared/frontend/node_modules/vue-loader/lib/selector?type=script&index=0!./AdminCard.vue"),
  /* template */
  require("!!../../../../../../../shared/frontend/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-c16dce1e\"}!../../../../../../../shared/frontend/node_modules/vue-loader/lib/selector?type=template&index=0!./AdminCard.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/home/alarmplan/staging/releases/136/frontend/src/views/Admin/Components/AdminCard.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AdminCard.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c16dce1e", Component.options)
  } else {
    hotAPI.reload("data-v-c16dce1e", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/Admin/Components/AdminCard.vue
// module id = 84
// module chunks = 1